<template>
    <div class="row" :data-expand="isExpand ? true : null">
        <div class="cells" v-on:click="toggleExpand()">
            <span class="cell" data-size="status" data-align="center">
                <span class="icon-status" :data-icon="histItem.userNm == 'System' ? 'system' : 'user'" :title="histItem.userNm == 'System' ? 'System' : 'User'">System</span>
            </span>
            <span class="cell" data-size="date">
                <time datetime="">{{convertUtcTimezoneToLocal(histItem.timeLine)}}</time>
            </span>
            <span class="cell" data-size="type">
                {{ $t('AUDIT.FILTER.REGION_SETTING')}}
            </span>
            <span class="cell" data-size="user">
                {{histItem.userNm}}
            </span>
            <span class="cell">
                {{$t('AUDIT.LABEL.CASE.MODIFY_REGION_SETTING')}}
            </span>
            <span class="cell" data-align="center">
                <button type="button" class="buttons-icon" data-type="ghost" data-icon="expand" :data-expand="isExpand ? true : null">collapse / expand</button>
            </span>
        </div>

        <div class="expand-container">
            <!-- inner tables -->
            <table class="tbl-inner">
                <caption>{{ $t('AUDIT.LABEL.CASE.CREATE_COPY_DELETE_POLICY')}}</caption>
                <colgroup>
                    <col style="width: 185px;">
                </colgroup>
                <thead>
                <tr>
                    <th scope="col">{{ $t('AUDIT.LABEL.HEADER.ITEM')}}<!--항목--></th>
                    <th scope="col">{{ $t('AUDIT.LABEL.HEADER.FROM')}}</th>
                    <th scope="col">{{ $t('AUDIT.LABEL.HEADER.TO')}}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <th>{{ $t('AUDIT.REGION.NAME')}}</th>
                    <td>
                        <span v-for="(bfregion, bfIdx) of listBfRegion" class="item" :key="bfIdx">{{bfregion}}</span>
                    </td>
                    <td>
                        <span v-for="(afRegion, afIdx) of listAfRegion" class="item" :key="afIdx">
                            <template v-if="afRegion.isAdd"><ins>{{afRegion.value}}</ins></template>
                            <template v-else><span v-bind:class="afRegion.isDelete ? 'delete-region' : ''">{{afRegion.value}}</span></template>
                        </span>
                    </td>
                </tr>
                </tbody>
            </table>

        </div>
    </div>

</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: 'ExpandRegionUpdate',
        props: ['histItem'],
        data: function() {
          return {
              isExpand: false,
              listBfRegion: [],
              listAfRegion: []
          }
        },
        computed: {
            ...mapGetters({
                curCmpnId: 'user/curCmpnId'
            }),
            getLocale: function() {
                return this.$i18n.locale
            }
        },
        created(){
            this.initData();
        },
        methods: {
            convertUtcTimezoneToLocal: function(date) {
                return date === null ? '-' : this.Common.convertUtcTimezoneToLocalByLang(date, this.getLocale)
            },
            toggleExpand: function(){
                this.isExpand = !this.isExpand;
            },
            parseObject(object) {
                object = object || null;
                return JSON.parse(object) || {};
            },
            initData() {
                let tempBfRegion = this.parseObject(this.histItem.bfEvntLog).listRegion;
                let tempAfRegion = this.parseObject(this.histItem.evntLog).listRegion;
                let listDeleteRegion = [];
                let listAfRegion = [];
                (tempBfRegion || []).forEach(bfRegion => {
                    if (_.indexOf(tempAfRegion, bfRegion) === -1) {
                        listDeleteRegion.push({
                            isDelete: true,
                            value: bfRegion
                        });
                    } 
                });

                (tempAfRegion || []).forEach(afRegion => {
                    if (_.indexOf(tempBfRegion, afRegion) != -1) {
                        listAfRegion.push({
                            isAdd: false,
                            value: afRegion
                        });
                    } else {
                        listAfRegion.push({
                            isAdd: true,
                            value: afRegion
                        });
                    }
                });

                listAfRegion = listAfRegion.concat(listDeleteRegion);
                this.listBfRegion = _.orderBy(tempBfRegion, [], ['asc']);
                this.listAfRegion = _.orderBy(listAfRegion, ['value'], ['asc']);
            }
        }

    }
</script>
<style scoped>
.delete-region {
    color: #999999;
    text-decoration: line-through;
    line-height: 1.63636em;
    border: 1px dashed #DFE3E8;
    background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/audit/expand/regionUpdate.vue